import React from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 20,
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
  },
  heading: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
  },
  sectionTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    color: '#667eea',
    borderLeft: '4px solid #667eea',
    paddingLeft: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
    height: '2px',
  },
  listItem: {
    paddingLeft: 0,
    marginBottom: theme.spacing(1),
  },
  listItemText: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
}));

const UserManual = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h4" className={classes.heading}>
          User Manual for Event Management Dashboard
          </Typography>
          {/* <Typography variant="body2" color="textSecondary" gutterBottom>
            Last Updated: 2nd Oct 2025
          </Typography> */}
          <Divider className={classes.divider} />

          <Typography variant="h6" className={classes.sectionTitle}>
          1. Overview
          </Typography>
          <Typography variant="body1">
          After successfully logging into the Event Management System, you will be directed to the Dashboard. On the left-hand side, a navigation panel will appear, providing access to the following sections:
          </Typography>

         <br></br>
          <Typography variant="body1">
          • Event Details
          </Typography>
          <Typography variant="body1">
          • Event
          </Typography><Typography variant="body1">
          • Bank Details
          </Typography><Typography variant="body1">
          • Report
          </Typography><Typography variant="body1">
          • Configurations
          </Typography><Typography variant="body1">
          • Coupon
          </Typography>

          {/* <Typography variant="body1">
            No refunds will be issued for customer-initiated cancellations or
            no-shows.
          </Typography> */}

          <Typography variant="h6" className={classes.sectionTitle}>
          2. Event Details
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
          Adding Event Details
          </Typography>
          <Typography variant="body1">
        1. From the left panel, select Event Details.
          </Typography>
          <Typography variant="body1">
          2. On the top-right corner, click the “Add Event Details” button.
          </Typography>
          <Typography variant="body1">
          3. A form will appear — fill in the required details:
          </Typography>
          <Typography variant="body1">
          - Event Name
          </Typography>
          <Typography variant="body1">
              - Status
          </Typography>
          <Typography variant="body1">
          - From Date
          </Typography>
          <Typography variant="body1">
          - To Date
          </Typography>
          <Typography variant="body1">
          - From Time
          </Typography>
          <Typography variant="body1">
          - To Time
          </Typography>
          <Typography variant="body1">
          - Description
          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          3. Event
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
          Adding a New Event
          </Typography>
          
          <Typography variant="body1">
        1. Go to the Event page from the left-side panel.
          </Typography>
          <Typography variant="body1">
         2.  On the top-right corner, click “Add Event”.
          </Typography>
          <Typography variant="body1">
          3. A form will open — fill in the following information:
          </Typography>
          <Typography variant="body1">
          - Company Name
          </Typography>
          <Typography variant="body1">
              - Event Name
          </Typography>
          <Typography variant="body1">
          - Status
          </Typography>
          <Typography variant="body1">
          - Select Payment Method
          </Typography>
          <Typography variant="body1">
          - Location
          </Typography>
          <Typography variant="body1">
          - Adult Price
          </Typography>
          <Typography variant="body1">
          - Child Price
          </Typography>
          <Typography variant="body1">
          - Ticket Price
          </Typography>
          <Typography variant="body1">
          - QR Name
          </Typography>
          <Typography variant="body1">
          - Additional Features
          </Typography>
          <Typography variant="body1">
         4. Click the Add button to save your event.
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
          Once added, you can:
          </Typography>
          <Typography variant="body1">
          • View the QR Code and Poster generated for the event.
          </Typography>
          <Typography variant="body1">
          • Customers can scan the QR code to directly purchase tickets.
          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          4. Bank Details
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
          Adding Bank Account
          </Typography>
          <Typography variant="body1">
        1. Navigate to the Bank Details page.
          </Typography>
          <Typography variant="body1">
        2. Click on the “Add Bank Account” button.
          </Typography>
          <Typography variant="body1">
        3. A form will appear — enter your bank account information.
          </Typography>
          <Typography variant="body1">
          2. Click on the “Add Bank Account” button.
          </Typography>
          <Typography variant="body1">
        3. A form will appear — enter your bank account information.
          </Typography>
          <Typography variant="body1">  
          4. Click Add to save the details.
          </Typography>
          <Typography variant="body1">
          Your bank account will now be added and available for transactions.
          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          5. Reports
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
          Viewing Reports
          </Typography>
          <Typography variant="body1">
          1. Go to the Reports page from the left panel.
          </Typography>
          <Typography variant="body1">
          2. You can search by date and park name.
          </Typography>
          <Typography variant="body1">
          3. The page will display:
          </Typography>
          <Typography variant="body1">
          - Total tickets booked
          </Typography>
          <Typography variant="body1">
          - Total amount collected
          </Typography><br></br>
          <Typography variant="body1">
          This helps in tracking event performance and financial summaries.
          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          5. Search
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
           Searching Tickets
          </Typography>
          <Typography variant="body1">
          1. Navigate to the Search page.
          </Typography>
          <Typography variant="body1">
          2. Search for tickets using relevant details.
          </Typography>
          <Typography variant="body1">
          3. You can check:
          </Typography>
          <Typography variant="body1">
          - Whether the ticket is scanned or not scanned.
          </Typography>
          <Typography variant="body1">
          - Once a QR code is scanned, it becomes invalid and cannot be reused.
          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          7. Configurations
          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          Managing Configuration Keys
          </Typography>
          <Typography variant="body1">
          1. Open the Configurations page.
          </Typography>
          <Typography variant="body1">
          2. You will see all MID Numbers, Access Keys, and corresponding Park Names.
          </Typography>
          <Typography variant="body1">
          3. You can also add a new configuration key if needed.          </Typography>
          <Typography variant="h6" className={classes.sectionTitle}>
          8. Coupon
          </Typography>
          <Typography variant="h8" className={classes.sectionTitle}>
          Managing Coupons
          </Typography>
          <Typography variant="body1">
          1. Go to the Coupon page.  
                 </Typography>
                 <Typography variant="body1">
                 2. Here, you can add coupons to provide discounts or special offers for your events. 
                 </Typography>
                 <Typography variant="h6" className={classes.sectionTitle}>
          9. Summary
          </Typography>
            <Typography variant="body1">
            The Event Management Dashboard allows you to:            
                </Typography>
        
          <Typography variant="body1">
          • Add and manage event details efficiently.
                    </Typography>
                    <Typography variant="body1">
                    • Track bookings and payments.
                    </Typography>
                    <Typography variant="body1">
                    • Monitor scanned tickets and prevent duplication.
                    </Typography>
                    <Typography variant="body1">
                    • Manage bank details, configurations, and promotional coupons — all from one platform.                    </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default UserManual;
